export default {
  data() {
    return {
      importDropdownData: {
        mobileDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortImports(this.teamsSettings[this.$route.params.team].listsSettings.imports.order.col, "ASC");
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortImports(this.teamsSettings[this.$route.params.team].listsSettings.imports.order.col, "DESC");
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
          {
            title: this.$t("dropdowns.sortingBy"),
            options: [
              {
                label: this.$t("imports.title"),
                key: "title",
                method: () => {
                  this.sortImports(
                    "title",
                    this.teamsSettings[this.$route.params.team].listsSettings.imports.order.dir
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("stati.status.title"),
                key: "status",
                method: () => {
                  this.sortImports(
                    "status",
                    this.teamsSettings[this.$route.params.team].listsSettings.imports.order.dir
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("imports.updated"),
                key: "updated_at",
                method: () => {
                  this.sortImports(
                    "updated_at",
                    this.teamsSettings[this.$route.params.team].listsSettings.imports.order.dir
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
        ],
        sortMainColDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            key: "title",
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortImports("title", "ASC");
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortImports("title", "DESC");
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
        ],
        showAsFirstColDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            disabled: false,
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortImports(
                    this.teamsSettings[this.$route.params.team].listsSettings.imports.showAs.firstCol.key,
                    "ASC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
                disabled: false,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortImports(
                    this.teamsSettings[this.$route.params.team].listsSettings.imports.showAs.firstCol.key,
                    "DESC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
                disabled: false,
              },
            ],
          },
          {
            title: this.$t("dropdowns.showAs"),
            options: [
              {
                label: this.$t("stati.status.title"),
                key: "status",
                method: () => {
                  this.changeCol({
                    list: "imports",
                    showAs: {
                      firstCol: {
                        label: "stati.status.title",
                        key: "status",
                        format: "formatImportStatus",
                        size: 1,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("imports.updated"),
                key: "updated_at",
                method: () => {
                  this.changeCol({
                    list: "imports",
                    showAs: {
                      firstCol: {
                        label: "imports.updated",
                        key: "updated_at",
                        format: "dateFromNow",
                        size: 1,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
        ],
        showAsSecondColDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            disabled: false,
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortImports(
                    this.teamsSettings[this.$route.params.team].listsSettings.imports.showAs.secondCol.key,
                    "ASC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
                disabled: false,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortImports(
                    this.teamsSettings[this.$route.params.team].listsSettings.imports.showAs.secondCol.key,
                    "DESC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
                disabled: false,
              },
            ],
          },
          {
            title: this.$t("dropdowns.showAs"),
            options: [
              {
                label: this.$t("stati.status.title"),
                key: "status",
                method: () => {
                  this.changeCol({
                    list: "imports",
                    showAs: {
                      secondCol: {
                        label: "stati.status.title",
                        key: "status",
                        format: "formatImportStatus",
                        size: 2,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("imports.updated"),
                key: "updated_at",
                method: () => {
                  this.changeCol({
                    list: "imports",
                    showAs: {
                      secondCol: {
                        label: "imports.updated",
                        key: "updated_at",
                        format: "dateFromNow",
                        size: 2,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
        ],
      },
    };
  },
};
